



































































































































































































import ripple from "../components/ripple.vue"
import inlineText from "../components/inlineTextEdit.vue"
import multiLineEdit from "../components/multiLineEdit.vue"
import warningPopup, {WarningInterface} from "../components/warningPopup.vue"
import tooltip from "../components/tooltip.vue"
import loadIcon from "../components/loadIcon.vue"
import gbutton from "../components/button.vue"
import imageUpload from "../components/uploadImage.vue"
import checkbox from "../components/checkbox.vue"
import gTable, {Rows} from "../components/table.vue"
import userRow from "../components/userRow.vue"
import popup from "../components/warningPopup.vue"
import gmap from "../components/map.vue"
import moment,{ weekdays, Moment } from "moment";

import uuid from "uuid/v4";

import { frontendClient } from "../lib/client";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval } from "timers";
import axios from "axios";

export interface JobItem{
    id: string,
    relDay: -1,
    dayPriority: {[relDay: number]: number},
    distributionName: string,
    pointOfContact: string,
    clientName: string,
    location: string,
    description: string,
    color: string,
    letters: number,
    complete: boolean,
    startsAt: number,
    endsAt: number,
    purchaseOrderNumber?: string, // sensitive data, only admins can see
    totalCost?: number, // sensitive data, only admins can see
    groups:{
        id: string,
        isMyGroup?: boolean;
        complete: boolean,
        issues: string,
        photos: string[],
        dateString:string,
        members:{
            id: string,
            name: string,
            phoneNumber: string,
            hoursFinalised?: boolean,
            workedHours: number,
            workedMinutes:number,
            lettersPosted: number,
            userResponded?: boolean,
            userAccepted?: boolean,
        }[],
    }[],
}

@Component({
    components : {
        ripple,
        gbutton,
        tooltip,
        userRow,
        gmap,
        inlineText,
        loadIcon,
        multiLineEdit,
        checkbox,
        imageUpload,
        popup
    },
})
export default class JobView extends Vue{
    perc:number = 0;
    loadingPerc:number = 100;
    isAdmin:boolean = (frontendClient.userData.rank == "admin");
    editing:boolean = false;

    imageBinary:string = null;
    compeletedCheckbox:boolean;
    completeStages:number = 1; //0=none, 1=partial, 2=all

    jobItem:any = null;
    jobStart:string = null;
    jobEnd:string = null;

    isInGroup:boolean = false;

    anyAccepted:boolean = false;
    userAccepted:number[] = []; // 0=no reply, 1=accepted, 2=declined

    groupsOrdered:{} = {};

    jobUpdating:boolean = false;
    jobSaving:boolean[] = [];

    hoursEditDisplay:{
        userGroupID:string,
        member:{
            id: string,
            name: string,
            phoneNumber: string,
            hoursFinalised?: boolean,
            workedHours: number,
            workedMinutes:number,
            lettersPosted: number,
            userResponded?: boolean,
            userAccepted?: boolean,
        }
    } = {
        userGroupID:null,
        member: null,
    };

    imageChange(usergroup, newBinary:string[]){
        usergroup.photos = newBinary;
    }

    mounted(){
       this.$emit('scope','jobs');
       this.getJob()
    };

    async acceptJob(usergroup,userAcceptedIndex){
        let shouldProgress = false;
        let warning = new warningPopup();
        let warningItem:WarningInterface = {
            text:"Are you sure you wish to accept this job?",
            options:[
                {
                    text:"Accept job",
                    function: "resolve"
                },
                {
                    text: "No",
                    function: "reject"
                }
            ]
        }
        await warning.create(this, warningItem).then(() => {
            this.$set(this.userAccepted, userAcceptedIndex, 1)
            frontendClient.postEx("jobs/usergroups/offers/respond",{
                usergroupID: usergroup.id,
                isAccepting: true,
            })
        })
    }

    async rejectJob(usergroup,userAcceptedIndex){
        let shouldProgress = false;
        let warning = new warningPopup();
        let warningItem:WarningInterface = {
            text:"Are you sure you wish to decline this job?",
            options:[
                {
                    text:"Decline job",
                    function: "resolve"
                },
                {
                    text: "No",
                    function: "reject"
                }
            ]
        }
        await warning.create(this, warningItem).then(() => {
            this.$set(this.userAccepted, userAcceptedIndex, 2)
            frontendClient.postEx("jobs/usergroups/offers/respond",{
                usergroupID: usergroup.id,
                isAccepting: false,
            })
        })
    }

    async getJob() {
        this.jobItem = (await frontendClient.postEx("jobs/info",{
            jobID: this.$route.params.jobID,
        })).info;

        this.jobStart = moment(new Date(this.jobItem.startsAt)).format("ddd, D/M/YY");
        this.jobEnd = moment(new Date(this.jobItem.endsAt)).format("ddd, D/M/YY");

        let anyComplete:boolean = false;
        let anyIncomplete:boolean = false;

        for(let i=0;i < this.jobItem.groups.length;i++) {

            this.jobSaving[i] = false;
            
            if(this.jobItem.groups[i].complete == true){
                anyComplete = true;
            }
            if(this.jobItem.groups[i].complete !== true){
                anyIncomplete = true;
            }

            if(frontendClient.userData.rank == "staff"){
                for(let j=0;j < this.jobItem.groups[i].members.length;j++) {
                    if(this.jobItem.groups[i].members[j].id == frontendClient.userData.userID){
                        if(this.jobItem.groups[i].members[j].userResponded){
                            if(this.jobItem.groups[i].members[j].userAccepted == true){
                                this.userAccepted[i] = 1;
                                this.anyAccepted = true;
                                this.isInGroup = true;
                            }else{
                                this.userAccepted[i] = 2;
                            }
                        }else{
                            this.userAccepted[i] = 0;
                            this.isInGroup = true;
                        }
                    }
                }
            }

            this.jobItemGroupDates(i);
            this.jobItemOrderGroups(i);
        }

        if(frontendClient.userData.rank == "admin"){
            this.isInGroup = true;
        }

        if(anyComplete){
            if(anyIncomplete){
                this.completeStages = 1;
            }else{
                this.completeStages = 2;
            }
        }else{
            this.completeStages = 0;
        }
    }

    jobItemGroupDates(i){
        this.jobItem.groups[i].dateString = moment(new Date(this.jobItem.groups[i].scheduledAt)).format("ddd, D/M/YY")
    }

    jobItemOrderGroups(i){
        if(frontendClient.userData.rank == "admin" || this.userAccepted[i] == 0 || this.userAccepted[i] == 1){
            if(this.groupsOrdered && this.groupsOrdered[this.jobItem.groups[i].dateString]){
                this.groupsOrdered[this.jobItem.groups[i].dateString].push(this.jobItem.groups[i]);
            }else{
                this.groupsOrdered[this.jobItem.groups[i].dateString] = [this.jobItem.groups[i]];
            }
        }
    }
    

    async submitCompletionCard(userGroup,index){
        if(userGroup.cardFinalised) {
            this.submitHours(userGroup,index);
            return;
        }

        Vue.set(this.jobSaving, index, true);

        // this.imageBinary
        // this.compeletedCheckbox

        if(frontendClient.userData.rank == "staff" && userGroup.complete !== true){
            setTimeout(() => {
                frontendClient.giveError("You must check 'Complete' to submit the card");
                Vue.set(this.jobSaving, index, false);
            },0)
            return;
        }

        let adjustedPhotos = [];
        for(let entry of userGroup.photos) {
            if(entry.startsWith('data:image/jpeg;base64,')) {
                adjustedPhotos.push(atob(entry.substring(23)));
            }
            else {
                // adjustedPhotos.push(entry.replace(/\?timestamp\=\d+\&nocache\=true/,""));
                adjustedPhotos.push(entry);
            }
        }

        this.loadingPerc = 10;
        await frontendClient.post("jobs/usergroups/submitcard",{
            usergroupID:userGroup.id,
            lettersPosted: parseInt(userGroup.lettersPosted),
            issues:userGroup.issues || "",
            photos: adjustedPhotos,
            forceUpdatePhotos: true,
            complete: userGroup.complete,
        },(progressEvent: ProgressEvent) => {
            this.loadingPerc = progressEvent.loaded / progressEvent.total * 100;
        }).then((resp) => {
            this.loadingPerc = 100;
            userGroup.cardFinalised = true;
            userGroup.photos = resp.newPhotos;
            for(let uploader of (this.$refs.imageUploader as imageUpload[])) {
                uploader.resetPhotos();
            }
        }).catch((e) => {
            this.loadingPerc = 100;
            frontendClient.giveError(e.toString());
        })

        this.submitHours(userGroup,index);

        setTimeout(() => {
            Vue.set(this.jobSaving, index, false);
            this.$forceUpdate();
        },250)
    }

    async updateCard(userGroup,index){
        Vue.set(this.jobSaving, index, true);

        let adjustedPhotos = [];
        for(let entry of userGroup.photos) {
            if(entry.startsWith('data:image/jpeg;base64,')) {
                adjustedPhotos.push(atob(entry.substring(23)));
            }
            else {
                // adjustedPhotos.push(entry.replace(/\?timestamp\=\d+\&nocache\=true/,""));
                adjustedPhotos.push(entry);
            }
        }
        
        this.loadingPerc = 10;
        await frontendClient.post("jobs/usergroups/submitcard",{
            usergroupID:userGroup.id,
            lettersPosted: parseInt(userGroup.lettersPosted),
            issues:userGroup.issues || "",
            photos: adjustedPhotos,
            forceUpdatePhotos: true,
            complete: userGroup.complete,
        },(progressEvent: ProgressEvent) => {
            if(progressEvent.total) {
                this.loadingPerc = progressEvent.loaded / progressEvent.total * 100;
            }
        }).then((resp) => {
            this.loadingPerc = 100;
            userGroup.complete = true;
            userGroup.cardFinalised = true;
            userGroup.photos = resp.newPhotos;
            for(let uploader of (this.$refs.imageUploader as imageUpload[])) {
                uploader.resetPhotos();
            }
        }).catch((e) => {
            this.loadingPerc = 100;
            frontendClient.giveError(e.toString());
        })

        setTimeout(() => {
            Vue.set(this.jobSaving, index, false);
            this.$forceUpdate();
        },250)
    }

    async submitHours(userGroup,index){
        let me = this.getMe(userGroup);
        if(!me || me.hoursFinalised) {return;}

        let workedHours = parseInt(me.workedHours);
        let workedMinutes = parseInt(me.workedMinutes);

        if((typeof workedHours !== "number") || isNaN(workedHours)) {return;}
        if((typeof workedMinutes !== "number") || isNaN(workedMinutes)) {return;}

        await frontendClient.post("jobs/usergroups/submithours",{
            usergroupID:userGroup.id,
            workedHours,
            workedMinutes,
        }).then(() => {
            this.getMe(userGroup).hoursFinalised = true;
        }).catch((e) => {
            frontendClient.giveError(e.toString());
        })
    }

    // OPEN PROMPT TO EDIT HOURS
    async editHours(group, member){
        // HERE GOES THE CODE TO EDIT THE HOURS
        this.hoursEditDisplay.userGroupID = group.id;
        this.hoursEditDisplay.member = member;
    }

    // SAVING NEW HOURS
    savingNewHours:boolean = true;
    async saveNewHours(hoursEditDisplay){
        await frontendClient.post("jobs/usergroups/edithours",{
            usergroupID: hoursEditDisplay.userGroupID,
            userID: hoursEditDisplay.member.id,
            workedHours: parseInt(hoursEditDisplay.member.workedHours),
            workedMinutes: parseInt(hoursEditDisplay.member.workedMinutes),
            hoursFinalised: true,
        }).then(() => {
            this.savingNewHours = false;
            this.hoursEditDisplay = {
                userGroupID:null,
                member: null,
            };
        }).catch((e) => {
            frontendClient.giveError(e.toString());
        })
    }


    openMap(){
        window.open(`https://www.google.com/maps/place/${this.jobItem.location}`,'_blank');
    }


    editJob(){
        this.editing = true;
    }
    async deleteJob(){
        let warning = new warningPopup();
        let warningItem:WarningInterface = {
            text:"Are you sure you wish to delete this job?",
            options:[
                {
                    text:"Delete job",
                    function: "resolve"
                },
                {
                    text: "No",
                    function: "reject"
                }
            ]
        }
        await warning.create(this, warningItem).then(() => {
            frontendClient.postEx("jobs/delete",{
                id: this.jobItem.id,
            }).then(() => {
                this.$router.replace({ name: 'admin-jobs' });
            })
        })
    }

    getMe(usergroup) {
        for(let member of usergroup.members) {
            if(member.isMe) {
                return member;
            }
        }

        return {
            workedHours: 0,
            workedMinutes: 0,
            hoursFinalised: true,
        };
    }

    async saveJob(){
        this.jobUpdating = true;
        let client = (this.$refs.newJobClient as HTMLInputElement).value
        let contact = (this.$refs.newJobContact as HTMLInputElement).value
        let name = (this.$refs.newJobName as HTMLInputElement).value
        let desc = (this.$refs.newJobDesc as HTMLInputElement).value
        let location = (this.$refs.newJobLocation as HTMLInputElement).value
        let letters = (this.$refs.newJobLetters as HTMLInputElement).value
        let cost = "0"
        let poNum = "0"
        await frontendClient.post("jobs/edit",{
            id: this.$route.params.jobID,
            distributionName: name,
            pointOfContact: contact,
            clientName: client,
            location: location,
            description: desc,
            letters: parseInt(letters),
            purchaseOrderNumber: poNum,
            totalCost: parseInt(cost),
        }).catch((err) => {
            frontendClient.giveError(err);
            return;
        })

        this.jobUpdating = false;
        this.editing = false;

        this.jobItem.pointOfContact = contact;
        this.jobItem.distributionName = name;
        this.jobItem.location = location;
        this.jobItem.description = desc;
        this.jobItem.letters = letters;
        this.jobItem.totalCost = cost;
        this.jobItem.purchaseOrderNumber = poNum;
    }
}
